const clearEditPatchForm = () => {
  return {
    type: 'CLEAR_EDIT_PATCH_FORM'
  };
}

export default clearEditPatchForm;



// WEBPACK FOOTER //
// ./src/actions/clearEditPatchForm.js